import { supabase } from "../../../providers/supabase/supabase";

export const processPayroll = async (runId: string | number) => {
  const { data, error } = await supabase.rpc("fn_process_payroll", {
    p_run_id: runId,
  });
  if (error) throw error;
  return data;
};
